import React, { useEffect, useState } from 'react'

import { Column } from 'components/Flex'
import OrangeFridayBanner from 'assets/icons/orange-friday-banner.svg'
import PJBanner from 'assets/icons/pj-banner.svg'

import { Text } from '@interco/inter-ui/components/Text'
import { interWbSession } from '@interco/inter-webview-bridge'

const defaultTexts = {
  title: 'A sequência de check-ins foi quebrada',
  description:
    'Você perdeu seu progresso, mas não se preocupe: novas campanhas para ganhar pontos estarão disponíveis em breve.',
}

const ctaByAccountType: Record<'PF' | 'PJ', string> = {
  PF: 'Até lá, aproveite as ofertas da Orange Friday!',
  PJ: 'Até lá, aproveite as ofertas disponíveis!',
}

const bannerByAccountType: Record<'PF' | 'PJ', { src: string; alt: string }> = {
  PF: {
    src: OrangeFridayBanner,
    alt: 'Orange Friday Banner',
  },
  PJ: {
    src: PJBanner,
    alt: 'PJ Banner',
  },
}

export const BrokenSequence = () => {
  const [application, setApplication] = useState<'PF' | 'PJ'>()

  useEffect(() => {
    const fetchAppInfo = async () => {
      const appInfo = await interWbSession.getAppInfo()
      setApplication(appInfo.application)
    }
    fetchAppInfo()
  }, [])

  const accountType = application || 'PF'
  const { title, description } = defaultTexts
  const cta = ctaByAccountType[accountType]
  const { src, alt } = bannerByAccountType[accountType]

  return (
    <Column $gap="32px" $justifyContent="start" $alignItems="start">
      <img src={src} alt={alt} width="100%" />
      <Column $gap="16px" $alignItems="start">
        <Text variant="headline-h1" semiBold>
          {title}
        </Text>
        <Text variant="body-3">{description}</Text>
        <Text variant="body-3">{cta}</Text>
      </Column>
    </Column>
  )
}
